/**
 * Registers the offline service worker (built by vite-plugin-pwa with registerType "autoUpdate", so a new version
 * takes over by itself). A browser may refuse the registration (private windows, blocked site data, an extension,
 * a stale origin), and the reader works fine without it, so a refusal is ignored instead of becoming an unhandled
 * rejection and an error report.
 */
export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return
  // After load, so registering never competes with the first paint.
  const register = () => {
    try {
      navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {
        // Offline support is optional; nothing to tell the user.
      })
    } catch {
      // Same: the reader keeps working without the service worker.
    }
  }
  if (document.readyState === 'complete') register()
  else window.addEventListener('load', register, { once: true })
}
